import { useLocalNumber } from './useLocalNumber';
import { FieldTooltip } from './FieldTooltip';

interface NumberFieldProps {
  label: string;
  tooltip?: string;
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
}

export const NumberField = ({ label, tooltip, value, onChange, disabled }: NumberFieldProps) => {
  const { local, handleChange, handleBlur } = useLocalNumber(value, onChange);

  return (
    <div className="flex flex-col gap-1">
      <span className="flex items-center gap-1.5 text-xs text-[#999]">
        {label}
        {tooltip && <FieldTooltip text={tooltip} />}
      </span>
      <input
        type="text"
        inputMode="decimal"
        value={local}
        disabled={disabled}
        onChange={(e) => handleChange(e.target.value)}
        onBlur={handleBlur}
        className="w-full rounded border border-[#444] bg-[#2A2A2A] px-2 py-1 text-sm text-[#E8E8E8] focus:outline-none focus:border-[#C3D82E] disabled:opacity-50"
      />
    </div>
  );
};
